// Catalog of everything the admin app reports to Amplitude.
// Adding an event means adding its name here plus a builder next to it (see
// `enviar-comunicado/`), so the payload shape is never spelled out at the call site.

export interface AnalyticsEvent {
  name: string
  properties: { [key: string]: any }
}

// Sending a newsfeed topic ("comunicado") from the admin app.
export const ENVIAR_COMUNICADO = 'enviar_comunicado'

// A successful sign-in with credentials.
export const LOGIN = 'login'

// A day sheet saved from the attendance screen. One event per save, not per
// student mark: see `attendance-saved/`.
export const ATTENDANCE_SAVED = 'attendance_saved'

// ---- Billing events -------------------------------------------------------------
// These are emitted by the React app (/v2), which ships no Amplitude SDK of its own: they
// travel over the iframe bridge and are reported here. Their payload builders live in
// react/src/analytics — this file only owns the names, because the shell is what validates
// them (see HOSTED_EVENT_NAMES below).

// The billing screen was opened.
export const INVOICES_VIEWED = 'invoices_viewed'

// A batch of invoices ("facturas") was emitted.
export const INVOICE_CREATED = 'invoice_created'

// An admin approved a student payment receipt.
export const PAY_ORDER_APPROVED = 'pay_order_approved'

// An admin rejected a student payment receipt.
export const PAY_ORDER_REJECTED = 'pay_order_rejected'

/**
 * The only events the hosted React app is allowed to report. The iframe is same-origin and
 * ours, but the bridge is still a boundary: it may name an event from this list with flat
 * properties, and nothing else — no identify calls, no new names, no user properties.
 */
export const HOSTED_EVENT_NAMES = [
  INVOICES_VIEWED,
  INVOICE_CREATED,
  PAY_ORDER_APPROVED,
  PAY_ORDER_REJECTED
]
